import _ from 'lodash';
import { PAGE_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import { DELETE_ELEMENT } from '../element/actions/desktopElementActions';
import { isStaticElement } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import * as mobileElementActions from '../element/actions/mobileElementActions';
import * as elementLayoutActions from '../element/actions/elementLayoutActions';
import update from 'react-addons-update';
import { getParentIdFromChildId } from 'crazyEditor/redux/modules/element/helpers/elementChildrenHelpers';

export const SET_HOVERED_ELEMENT_ID = 'crazyEditor/stage/SET_HOVERED_ELEMENT_ID';
export const CLEAR_HOVERED_ELEMENT_ID = 'crazyEditor/stage/CLEAR_HOVERED_ELEMENT_ID';
export const SET_IS_DRAGGING_ELEMENT = 'crazyEditor/stage/SET_IS_DRAGGING_ELEMENT';
export const SET_DRAGGING_DIRECTION = 'crazyEditor/stage/SET_DRAGGING_DIRECTION';
export const SET_IS_RESIZING_PAGE_ELEMENT = 'crazyEditor/stage/SET_IS_RESIZING_PAGE_ELEMENT';
export const CLEAR_STAGE_STATE = 'crazyEditor/stage/CLEAR_STATE';
export const SET_SELECTED_ELEMENT_ID = 'crazyEditor/stage/SET_SELECTED_ELEMENT_ID';
export const CLEAR_SELECTED_ELEMENT_ID = 'crazyEditor/stage/CLEAR_SELECTED_ELEMENT_ID';
export const TOGGLE_SELECTED_ELEMENT_ID = 'crazyEditor/stage/TOGGLE_SELECTED_ELEMENT_ID';
export const SET_EDITING_ELEMENT_ID = 'crazyEditor/stage/SET_EDITING_ELEMENT_ID';
export const CLEAR_EDITING_ELEMENT_ID = 'crazyEditor/stage/CLEAR_EDITING_ELEMENT_ID';
export const SET_STAGE_LAYOUT = 'crazyEditor/stage/SET_STAGE_LAYOUT';
export const SET_MOUSE_DRAG_START_POSITION = 'crazyEditor/stage/SET_MOUSE_DRAG_START_POSITION';
export const SET_MOUSE_POSITION = 'crazyEditor/stage/SET_MOUSE_POSITION';
export const UPDATE_MOUSE_POSITION_BY_DELTA = 'crazyEditor/stage/UPDATE_MOUSE_POSITION_BY_DELTA';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_HOVERED_ELEMENT_ID:
      return {
        ...state,
        hoveredElementId: action.elementId
      };
    case CLEAR_HOVERED_ELEMENT_ID:
      return {
        ...state,
        hoveredElementId: ''
      };
    case SET_IS_DRAGGING_ELEMENT:
      return {
        ...state,
        isDraggingElement: action.flag,
        editingElementId: action.flag ? null : state.editingElementId,
      };
    case SET_DRAGGING_DIRECTION:
      return {
        ...state,
        draggingDirection: action.direction,
        isResizingElement: true,
        mouseDragStartPosition: action.position,
        mousePosition: action.position,
      };
    case SET_IS_RESIZING_PAGE_ELEMENT:
      return {
        ...state,
        selectedElementIds: [PAGE_ELEMENT_ID],
        isResizingPageElement: action.flag,
        pageElementResizeDirection: action.direction
      };
    case CLEAR_STAGE_STATE:
      return {
        ...state,
        isDraggingElement: false,
        isResizingElement: false,
        hoveredElementId: '',
        isResizingPageElement: false,
        pageElementResizeDirection: '',
        draggingDirection: '',
        editingElementId: null,
        mouseDragStartPosition: null,
        mousePosition: null,
      };
    case SET_SELECTED_ELEMENT_ID:
      const isArrayElementIds = _.isArray(action.elementIds);
      return {
        ...state,
        selectedElementIds: isArrayElementIds ? action.elementIds : [action.elementIds],
      };
    case CLEAR_SELECTED_ELEMENT_ID:
      return {
        ...state,
        selectedElementIds: action.setPageElementIdAfterClear ? [PAGE_ELEMENT_ID] : []
      };
    case mobileElementActions.HIDE_MOBILE_ELEMENT:
      return {
        ...state,
        selectedElementIds: [PAGE_ELEMENT_ID],
      };
    case DELETE_ELEMENT:
      return {
        ...state,
        selectedElementIds: [PAGE_ELEMENT_ID],
        hoveredElementId: ''
      };
    case TOGGLE_SELECTED_ELEMENT_ID:
      let updatedSelectedElementIdsState;
      if (_.some(state.selectedElementIds, isStaticElement) !== isStaticElement(action.elementId)) { // static elements can not be in selection together with non static elements
        if (isStaticElement(action.elementId)) {
          return state;
        }
        updatedSelectedElementIdsState = [action.elementId];
      } else {
        if (state.selectedElementIds.indexOf(action.elementId) === -1) {
          updatedSelectedElementIdsState = state.selectedElementIds.concat(action.elementId);
        } else {
          updatedSelectedElementIdsState = _.reject(state.selectedElementIds, id => id === action.elementId);
        }
      }
      return {
        ...state,
        selectedElementIds: updatedSelectedElementIdsState,
      };
    case SET_EDITING_ELEMENT_ID:
      return {
        ...state,
        editingElementId: action.elementId,
        isDraggingElement: action.elementId ? false : state.isDraggingElement,
      };
    case CLEAR_EDITING_ELEMENT_ID:
      return {
        ...state,
        editingElementId: null
      };
    case SET_STAGE_LAYOUT:
      return {
        ...state,
        layout: action.layout
      };
    case SET_MOUSE_DRAG_START_POSITION:
      return {
        ...state,
        mouseDragStartPosition: action.position,
        mousePosition: action.position,
        isDraggingElement: true,
        editingElementId: null,
      };
    case SET_MOUSE_POSITION:
      if (!state.mouseDragStartPosition) {
        break;
      }
      const mousePosition = action.position;
      if ((Math.abs(state.mousePosition.x - mousePosition.x) + Math.abs(state.mousePosition.y - mousePosition.y)) > 1 ||
        (Math.abs(state.mouseDragStartPosition.x - mousePosition.x) + Math.abs(state.mouseDragStartPosition.y - mousePosition.y)) > 1) {
        let {selectedElementIds} = state;
        const parentId = getParentIdFromChildId(state.selectedElementIds[0]);
        if (parentId) {
          selectedElementIds = [parentId];
        }
        return {
          ...state,
          mousePosition,
          selectedElementIds,
        };
      }
      break;
    case elementLayoutActions.DRAG_COMPLETE_AND_UPDATE_ELEMENTS_SIZE:
    case elementLayoutActions.DRAG_COMPLETE_AND_UPDATE_ELEMENTS_POSITION:
      return {
        ...state,
        mousePosition: null,
        mouseDragStartPosition: null,
        isDraggingElement: false,
        isResizingElement: false,
      };
    case UPDATE_MOUSE_POSITION_BY_DELTA:
      return update(state, {
        mousePosition: {
          x: {
            $apply: x => action.delta.deltaX ? x + action.delta.deltaX : x,
          },
          y: {
            $apply: y => action.delta.deltaY ? y + action.delta.deltaY : y,
          },
        }
      });
    default:
      return state;
  }
  return state;
}

export function setHoveredElementId(elementId) {
  return {type: SET_HOVERED_ELEMENT_ID, elementId};
}

export function clearHoveredElementId() {
  return {type: CLEAR_HOVERED_ELEMENT_ID};
}

export function setIsDraggingElement(flag) {
  return {type: SET_IS_DRAGGING_ELEMENT, flag};
}

export function setDraggingDirection(direction, position) {
  return {type: SET_DRAGGING_DIRECTION, direction, position};
}

export function setIsResizingPageElement(flag, direction) {
  return {type: SET_IS_RESIZING_PAGE_ELEMENT, flag, direction};
}

export function clearStageState() {
  return {type: CLEAR_STAGE_STATE};
}

export function setSelectedElementIds(elementIds) {
  return {type: SET_SELECTED_ELEMENT_ID, elementIds};
}

export function setEditingTextElementId(elementId) {
  return {type: SET_EDITING_ELEMENT_ID, elementId};
}

export function clearSelectedElementIds(setPageElementIdAfterClear = false) {
  return {type: CLEAR_SELECTED_ELEMENT_ID, setPageElementIdAfterClear};
}

export function toggleSelectedElementId(elementId) {
  return {type: TOGGLE_SELECTED_ELEMENT_ID, elementId};
}

export function setStageLayout(layout) {
  return {type: SET_STAGE_LAYOUT, layout};
}

export function clearEditingTextElementId() {
  return {type: CLEAR_EDITING_ELEMENT_ID};
}

export function setMouseDragStartPosition(position) {
  return {type: SET_MOUSE_DRAG_START_POSITION, position};
}

export function setMousePosition(position) {
  return {type: SET_MOUSE_POSITION, position};
}

export function updateMousePositionByDelta(delta) {
  return {type: UPDATE_MOUSE_POSITION_BY_DELTA, delta};
}
